
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kiosks/[cName]/lock",
      function () {
        return require("private-next-pages/kiosks/[cName]/lock.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kiosks/[cName]/lock"])
      });
    }
  